import { NgModule } from '@angular/core';
import { ApxCheckboxComponent } from './checkbox.component';

@NgModule({
    imports: [ApxCheckboxComponent],
    exports: [ApxCheckboxComponent]
})
export class ApxCheckboxModule {}

// Re-export component for barrel exports
export { ApxCheckboxComponent } from './checkbox.component';
